module.exports = __webpack_public_path__ + "img/img (1).8ba22cf1.jpg";